import { createContext } from 'react'

export const CreateCartoMapContext = createContext({
    accountId: null,

    visualisationName: '',
    setVisualisationName: () => {},

    fromProject: {
        zones: [],
        setZones: () => {} 
    },
    zonesSelected: {
        zones: [],
        setZones: () => {}
    },

    projects: [],

    selectedFromProject: null,
    setSelectedFromProject: () => {},

    fromDisplayedZones: [],
    setFromDisplayedZones: () => {},

    resetForm: () => {},
})